<template>
  <div class="mt-5">
    <section-title
      content="Detalles de la propuesta"
      icon="fas fa-info"
      reverse
    />
    <section-title-collapse
      v-for="(questionAnswers, key) in questionnaireQuestionSection"
      :key="key"
      :title="key"
    >
      <div v-for="(item, key) in questionAnswers" :key="key">
        <div
          v-if="
            item.questionAnswer.answer.text != null ||
              item.questionAnswer.answer.boolean != null
          "
          class="row mb-3"
        >
          <div class="col">
            <div class="color-gray-6 font-14 font-weight-normal">
              {{ item.questionAnswer.questionText }}
            </div>
            <div class="color-black font-14 font-weight-normal pl-3 mt-1">
              {{ item.questionAnswer.questionNumberLabel }}
            </div>
            <div
              class="color-black font-16 font-weight-normal"
              :class="item.questionAnswer.questionNumberLabel ? 'pl-3' : ''"
            >
              <template v-if="item.questionAnswer.answer.text">
                {{ item.questionAnswer.answer.text }}
              </template>
              <template v-else>
                {{ item.questionAnswer.answer.boolean | boolText }}
              </template>
            </div>
            <div
              v-if="
                Object.values(questionProposalType).includes(
                  item.questionAnswer.id
                ) && item.questionAnswer.answer.boolean
              "
            >
              <div class="color-gray-6 font-14 font-weight-normal mt-3">
                <template>
                  Nombre de la Corporación
                </template>
              </div>
              <div class="color-black font-16 font-weight-normal">
                <template>
                  {{ item.questionAnswer.answer.previousCompanyName }}
                </template>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else-if="
            item.questionAnswer.questionAnswerModeId == answerModes.Documento
          "
          class="bg-secondary-3 mt-3 rounded py-3 px-4"
        >
          <div class="row">
            <div class="col-md-6">
              <label class="data-title mb-0">Documento:</label>
              <h6>{{ item.questionAnswer.questionText | empty }}</h6>
            </div>
            <div class="col-md-4">
              <label class="data-title mb-0">Archivo:</label>
              <h6>{{ item.questionAnswer.answer.file.filename | empty }}</h6>
            </div>
            <div class="col-md-2 d-flex align-items-center justify-content-end">
              <div
                v-if="item.questionAnswer.answer.file.documentId"
                class="mt-3"
              >
                <action-button
                  :id="
                    'download-document' +
                      item.questionAnswer.answer.file.documentId
                  "
                  class="mr-2 bg-green border-green"
                  i="fas fa-file-download text-white mr-n1 pr-1"
                  @click="downloadDocument(item.questionAnswer.answer.file)"
                />
                <action-button
                  :id="
                    'view-document' + item.questionAnswer.answer.file.documentId
                  "
                  class="border-green bg-transparent"
                  i="fas fa-search-plus text-green mr-n1 pr-1"
                  @click="viewDocument(item.questionAnswer.answer.file)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section-title-collapse>
  </div>
</template>

<script>
//Component Libs
import SectionTitle from 'SectionTitle';
import SectionTitleCollapse from './SectionTitleCollapse';
import groupBy from 'lodash/groupBy';

//Services
import { getProposalRequestDetails } from '@/modules/proposalProcess/api.js';
import generalService from '@/modules/app/api';

//Const
const DOCUMENT_VIEWER_ROUTE_NAME = 'DocumentViewer';
import proposalQuestionAnswerModes from '@/utils/constants/ProposalQuestionAnswerModes';
import proposalProcessQuestionType from '@/utils/constants/proposalProcessQuestionType';

export default {
  name: 'ProposalDetails',
  components: {
    SectionTitle,
    SectionTitleCollapse,
  },
  props: {
    proposalRequestId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      questionnaireQuestionSection: [],
    };
  },
  computed: {
    answerModes() {
      return proposalQuestionAnswerModes;
    },
    questionProposalType() {
      return proposalProcessQuestionType;
    },
  },
  async mounted() {
    await this.getProposalRequestDetails();
  },
  methods: {
    async getProposalRequestDetails() {
      const result = (await getProposalRequestDetails(this.proposalRequestId))
        .data;
      this.questionnaireQuestionSection = groupBy(
        result,
        (questionAnswer) => questionAnswer.sectionName
      );
    },
    async downloadDocument({ documentId }) {
      generalService.downloadDocumentByAttachmentId(documentId);
    },
    async viewDocument({ documentId, filename: docName }) {
      const linkData = this.$router.resolve({
        name: DOCUMENT_VIEWER_ROUTE_NAME,
        query: { documentId, docName },
      });
      window.open(linkData.href, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.border-green {
  border-color: map-get($colors, 'green');
}
</style>
